export const STATUS_UNATHORIZED = 401

export const ERROR_DEFAULT = 'ERROR_DEFAULT'
